import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { toNumber } from 'lodash-es';
import SvgIcon from '@mui/material/SvgIcon';
import { styled } from '@mui/material/styles';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledSvgIcon = styled(SvgIcon, {
  shouldForwardProp: isStyledPropsValid
})(_ref => {
  let {
    size,
    width,
    height
  } = _ref;
  const sizeToNumber = toNumber(size);
  const isNumber = sizeToNumber > 0;
  const fontSizeValue = isNumber ? "".concat(sizeToNumber, "px") : size;
  return _objectSpread2({
    "&.MuiSvgIcon-root": {
      width: "".concat(width, "px"),
      height: "".concat(height, "px")
    }
  }, isNumber && {
    fontSize: fontSizeValue
  });
});
export { StyledSvgIcon, StyledSvgIcon as default };
//# sourceMappingURL=SvgIcon.styles.js.map